<template>
   <div>
       <common-training-header :in-header="true" :withUser="false" />

       <a-card size="small" type="inner" style="margin-top: 24px;">
           <a-skeleton :loading="loading" active>
               <a-radio-group v-model="params.type">
                   <a-radio-button value="all">All</a-radio-button>
                   <a-radio-button v-for="(v,k) in type" :key="k" :value="k">{{ v }}</a-radio-button>
               </a-radio-group>
               <br><br>
               <a-list class="comment-list" item-layout="horizontal" :data-source="items.data"
                       :pagination="{
                        current: items.current_page,
                        total: items.total,
                        defaultPageSize: items.per_page,
                        onChange: p => { params.page = p }
                    }">
                   <a-list-item slot="renderItem" slot-scope="r">
                       <a-comment :author="r.activity.user.name">
                           <a-avatar slot="avatar" :size="120" :src="r.activity.user.photo" :alt="r.activity.user.name" />
                           <blockquote slot="content">
                               {{ r.comment }}
                           </blockquote>
                           <a-tooltip slot="datetime" :title="moment(r.created_at).format('YYYY-MM-DD HH:mm:ss')">
                               <span>{{ moment(r.created_at).fromNow() }}</span>
                           </a-tooltip>
                           <template slot="actions">
                               <a-rate :value="r.score" allow-half disabled style="margin-right: 10px;" /> <strong>{{ r.score }}</strong>
                               <a-divider type="vertical" />
                               <span><strong>{{ type[r.category.type ]}}</strong></span>
                               <a-divider type="vertical" />
                               <span><strong>{{ r.material.name }}</strong></span>
                           </template>
                       </a-comment>
                   </a-list-item>
               </a-list>
           </a-skeleton>
       </a-card>
   </div>
</template>
<script>
const type = {
    acomodation: 'Akomodasi',
    event: 'Event',
    program: 'Program',
    material: 'Materi',
    inspirator: 'Inspirator'
}

export default {
    data() {
        return {
            loading: false,
            items: {},
            params: {
                page: 1,
                type: 'all'
            },
            type
        }
    },
    created() {
        this.items = this.getDefaultPagination()
    },
    methods: {
        getItems() {
            this.loading = true
            this.$http
                .get(this.routeUri('api.training.evaluation.suggestion'), {
                    params: this.params
                })
                .then((r) => this.items = r.data )
                .catch((e) => this.handleXhrError(e))
                .finally(() => this.loading = false)
        }
    },
    watch: {
        params: {
            deep: true,
            immediate: true,
            handler: function(b,a) {
                this.getItems()
            }
        }
    }
}
</script>

<style scoped>
.ant-comment-avatar img {
    width:  100%;
    height: 100%;
}
</style>
